import { TTemplate } from "../../../../utils/types";

export const templates: {
  template: TTemplate;
  templateDisplayName: string;
}[] = [
  {
    templateDisplayName: "Template 1",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 1000,
        backgroundColor: "#fff",
      },
      beforeImage: {
        position: { x: 40, y: 40 },
        size: { width: "44%", height: "92%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
        },
      },
      afterImage: {
        position: { x: 260 * 2, y: 40 },
        size: { width: "44%", height: "92%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
        },
      },
      images: [],
      texts: [],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 2",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 1000,
        backgroundColor: "#fff",
      },
      beforeImage: {
        position: { x: 40, y: 40 },
        size: { width: "44%", height: "92%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.4)",
        },
      },
      afterImage: {
        position: { x: 260 * 2, y: 40 },
        size: { width: "44%", height: "92%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.4)",
        },
      },
      images: [],
      texts: [],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 3",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 1000,
        backgroundColor: "#000",
      },
      beforeImage: {
        position: { x: 40, y: 40 },
        size: { width: "44%", height: "92%" },
        containerStyle: {},
        imageStyle: { width: "100%", height: "100%", objectFit: "cover" },
      },
      afterImage: {
        position: { x: 260 * 2, y: 40 },
        size: { width: "44%", height: "92%" },
        containerStyle: {},
        imageStyle: { width: "100%", height: "100%", objectFit: "cover" },
      },
      images: [],
      texts: [],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 4",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        backgroundColor: "#000",
        height: 1000,
      },
      beforeImage: {
        position: { x: 0, y: 0 },
        size: { width: "50%", height: "100%" },
        containerStyle: {},
        imageStyle: { width: "100%", height: "100%", objectFit: "cover" },
      },
      afterImage: {
        position: { x: 500, y: 0 },
        size: { width: "50%", height: "100%" },
        containerStyle: {},
        imageStyle: { width: "100%", height: "100%", objectFit: "cover" },
      },
      images: [],
      texts: [
        {
          content: "Before",
          position: { x: 250, y: 950 },
          containerStyle: {
            zIndex: 1,
          },
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 20 * 2,
            fontFamily: "Arial",
            color: "#fff",
            zIndex: 100,
          },
        },
        {
          content: "After",
          position: { x: 750, y: 950 },
          containerStyle: {
            zIndex: 1,
          },
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 20 * 2,
            fontFamily: "Arial",
            color: "#fff",
          },
        },
      ],
      divs: [
        {
          position: "relative",
          width: "100%",
          height: 50,
          backgroundColor: "#000",
          opacity: 0.5,
          top: 950,
          left: 0,
        },
      ],
    },
  },

  {
    templateDisplayName: "Template 5",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 1000,
        backgroundColor: "#fff",
      },
      beforeImage: {
        position: { x: 0, y: 140 },
        size: { width: "50%", height: "70%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
        },
      },
      afterImage: {
        position: { x: 500, y: 140 },
        size: { width: "50%", height: "70%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
        },
      },
      images: [],
      texts: [],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 6",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 1000,
        backgroundColor: "#475772",
      },
      beforeImage: {
        position: { x: 50, y: 200 },
        size: { width: "43%", height: "60%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          borderBottomWidth: 80,
          borderBottomColor: "#fff",
          borderBottomStyle: "solid",
          boxSizing: "border-box",
          borderRadius: 15,
          overflow: "hidden",
        },
      },
      afterImage: {
        position: { x: 525, y: 200 },
        size: { width: "43%", height: "60%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          borderBottomWidth: 80,
          borderBottomColor: "#fff",
          borderBottomStyle: "solid",
          boxSizing: "border-box",
          borderRadius: 15,
          overflow: "hidden",
        },
      },
      images: [
        {
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_SQUARE_0001.png",
          position: { x: 50, y: 830 },
          size: { width: "15%", height: "15%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
      ],
      texts: [
        {
          content: "Before",
          position: { x: 260, y: 730 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 20 * 2,
            color: "#475772",
            fontFamily: "Inter",
          },
        },
        {
          content: "After",
          position: { x: 740, y: 730 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 20 * 2,
            color: "#475772",
            fontFamily: "Inter",
          },
        },
        {
          content: "PROCEDURE TITLE",
          position: { x: 500, y: 80 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 60,
            color: "#fff",
            fontFamily: "Inter",
          },
        },
        {
          content: "Contact Info Etc",
          position: { x: 950, y: 880 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-100%)",
            textWrap: "nowrap",
            fontSize: 22,
            color: "#fff",
            fontFamily: "Inter",
          },
        },
        {
          content:
            "Short procedure description or necessary information. Keep info to two lines maximum.",
          position: { x: 230, y: 880 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            width: 500,
            fontSize: 22,
            color: "#fff",
            fontFamily: "Inter",
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 7",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 1000,
        backgroundColor: "#413D3D",
      },
      beforeImage: {
        position: { x: 44, y: 310 },
        size: { width: "44%", height: "57%" },
        containerStyle: { backgroundColor: "#000" },
        imageStyle: { width: "100%", height: "100%", objectFit: "cover" },
      },
      afterImage: {
        position: { x: 510, y: 370 },
        size: { width: "44%", height: "57%" },
        containerStyle: { backgroundColor: "#000" },
        imageStyle: { width: "100%", height: "100%", objectFit: "cover" },
      },
      images: [
        {
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_SQUARE_0001.png",
          position: { x: 790, y: 90 },
          size: { width: "14%", height: "14%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
      ],
      texts: [
        {
          content: "Procedure Title",
          position: { x: 44, y: 90 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            textWrap: "nowrap",
            fontSize: 82,
            color: "#fff",
            fontFamily: "Instrument Serif",
          },
        },
        {
          content:
            "Short procedure description or necessary information. Keep info to two lines maximum.",
          position: { x: 44, y: 200 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            width: 700,
            fontSize: 22,
            color: "#fff",
            fontFamily: "Inter",
          },
        },
        {
          content: "Before",
          position: { x: 266, y: 840 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 44,
            backgroundColor: "#fff",
            paddingTop: 6,
            paddingBottom: 6,
            width: 340,
            textAlign: "center",
            color: "#413D3D",
            fontFamily: "Instrument Serif",
          },
        },
        {
          content: "After",
          position: { x: 732, y: 336 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 44,
            backgroundColor: "#fff",
            paddingTop: 6,
            paddingBottom: 6,
            width: 340,
            textAlign: "center",
            color: "#413D3D",
            fontFamily: "Instrument Serif",
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 8",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#F8E7E3",
      },
      beforeImage: {
        position: { x: 40, y: 130 },
        size: { width: "42%", height: "57%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          rotate: "-6deg",
          borderTopWidth: 8,
          borderLeftWidth: 8,
          borderBottomWidth: 48,
          borderRightWidth: 8,
          borderColor: "#fff",
          borderStyle: "solid",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          boxSizing: "border-box",
        },
      },
      afterImage: {
        position: { x: 245, y: 120 },
        size: { width: "42%", height: "57%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          rotate: "9deg",
          borderTopWidth: 8,
          borderLeftWidth: 8,
          borderBottomWidth: 48,
          borderRightWidth: 8,
          borderColor: "#fff",
          borderStyle: "solid",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          boxSizing: "border-box",
        },
      },
      images: [
        {
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_SQUARE_0001.png",
          position: { x: 408, y: 32 },
          size: { width: "12%", height: "12%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
      ],
      texts: [
        {
          content: "PROCEDURE TITLE",
          position: { x: 30, y: 40 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            textWrap: "nowrap",
            fontSize: 27,
            color: "#000",
            zIndex: 2,
            fontFamily: "Work Sans",
          },
        },
        {
          content: "Short procedure description ornecessary information.",
          position: { x: 30, y: 80 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            width: 180,
            fontSize: 11,
            color: "#000",
            fontFamily: "Inter",
            zIndex: 2,
          },
        },
        {
          content: "BEFORE",
          position: { x: 170, y: 452 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            fontSize: 18,
            color: "#000",
            fontFamily: "Work Sans",
          },
        },
        {
          content: "AFTER",
          position: { x: 330, y: 452 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            fontSize: 18,
            color: "#000",
            fontFamily: "Work Sans",
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 9",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500 * 2,
        backgroundColor: "#EDE6E1",
      },
      beforeImage: {
        position: { x: 50 * 2, y: 140 * 2 },
        size: { width: "38%", height: "59%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          borderLeftWidth: 0 * 2,
          borderRightWidth: 0 * 2,
          borderBottomWidth: 0 * 2,
          borderTopWidth: 48 * 2,
          borderColor: "#fff",
          borderStyle: "solid",
          borderRadius: 7 * 2,
          overflow: "hidden",
          boxSizing: "border-box",
        },
      },
      afterImage: {
        position: { x: 255 * 2, y: 170 * 2 },
        size: { width: "38%", height: "59%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          borderLeftWidth: 0 * 2,
          borderRightWidth: 0 * 2,
          borderTopWidth: 0 * 2,
          borderBottomWidth: 48 * 2,
          borderColor: "#fff",
          borderStyle: "solid",
          borderRadius: 7 * 2,
          overflow: "hidden",
          boxSizing: "border-box",
        },
      },
      images: [
        {
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_SQUARE_0001.png",
          position: { x: 415 * 2, y: 18 * 2 },
          size: { width: "14%", height: "14%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
        {
          src: "https://clinic-os.com/user-app-assets/template-other-images/x-0001.icon.png",
          position: { x: 30 * 2, y: 410 * 2 },
          size: { width: "10%", height: "10%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
        {
          src: "https://clinic-os.com/user-app-assets/template-other-images/arrow-left-0001.icon.png",
          position: { x: 225 * 2, y: 265 * 2 },
          size: { width: "10%", height: "10%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
        {
          src: "https://clinic-os.com/user-app-assets/template-other-images/heart-0001.icon.png",
          position: { x: 420 * 2, y: 145 * 2 },
          size: { width: "10%", height: "10%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
      ],
      texts: [
        {
          content: "Procedure Title",
          position: { x: 250 * 2, y: 45 * 2 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 26 * 2,
            color: "#000",
            fontFamily: "Work Sans",
          },
        },
        {
          content:
            "Short procedure description or necessary information. Keep info to two lines maximum.",
          position: { x: 250 * 2, y: 83 * 2 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textAlign: "center",
            width: 283 * 2,
            fontSize: 10 * 2,
            color: "#000",
            fontFamily: "Work Sans",
          },
        },
        {
          content: "Before",
          position: { x: 145 * 2, y: 150 * 2 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            fontSize: 18 * 2,
            color: "#000",
            fontFamily: "Work Sans",
          },
        },
        {
          content: "After",
          position: { x: 350 * 2, y: 428 * 2 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            fontSize: 18 * 2,
            color: "#000",
            fontFamily: "Work Sans",
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 10",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "rgba(25, 14, 4, 0.22)",
      },
      beforeImage: {
        position: { x: 20, y: 25 },
        size: { width: "44%", height: "71%" },
        containerStyle: {},
        imageStyle: {
          boxSizing: "border-box",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          paddingTop: 35,
          backgroundColor: "#fff",
          borderStyle: "solid",
          borderColor: "#3D2206",
          borderWidth: 2,
        },
      },
      afterImage: {
        position: { x: 260, y: 25 },
        size: { width: "44%", height: "71%" },
        containerStyle: {},
        imageStyle: {
          boxSizing: "border-box",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          paddingTop: 35,
          backgroundColor: "#fff",
          borderStyle: "solid",
          borderColor: "#3D2206",
          borderWidth: 2,
        },
      },
      images: [],
      texts: [
        {
          content: "Before",
          position: { x: 130, y: 32 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 21,
            fontFamily: "Arial",
          },
        },
        {
          content: "After",
          position: { x: 370, y: 32 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 21,
            fontFamily: "Arial",
          },
        },
        {
          content: "Procedure Title",
          position: { x: 41, y: 430 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            textWrap: "nowrap",
            fontSize: 26,
            fontFamily: "Arial",
            fontWeight: "lighter",
          },
        },
      ],
      divs: [
        {
          position: "absolute",
          top: 408,
          left: 20,
          width: "92%",
          height: "14%",
          backgroundColor: "#fff",
          borderWidth: 2,
          borderColor: "#3D2206",
          borderStyle: "solid",
          boxSizing: "border-box",
        },
      ],
    },
  },

  {
    templateDisplayName: "Template 12",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#F0EAE4",
      },
      beforeImage: {
        position: { x: 20, y: 25 },
        size: { width: "44%", height: "71%" },
        containerStyle: {},
        imageStyle: {
          boxSizing: "border-box",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          paddingTop: 35,
          backgroundColor: "#FBF8EF",
          borderStyle: "solid",
          borderColor: "#000",
          borderWidth: 2,
        },
      },
      afterImage: {
        position: { x: 260, y: 25 },
        size: { width: "44%", height: "71%" },
        containerStyle: {},
        imageStyle: {
          boxSizing: "border-box",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          paddingTop: 35,
          backgroundColor: "#FBF8EF",
          borderStyle: "solid",
          borderColor: "#000",
          borderWidth: 2,
        },
      },
      images: [],
      texts: [
        {
          content: "Before",
          position: { x: 130, y: 32 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 21,
            fontFamily: "Arial",
          },
        },
        {
          content: "After",
          position: { x: 370, y: 32 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 21,
            fontFamily: "Arial",
          },
        },
        {
          content: "Procedure Title",
          position: { x: 41, y: 430 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            textWrap: "nowrap",
            fontSize: 26,
            fontFamily: "Arial",
            fontWeight: "lighter",
          },
        },
      ],
      divs: [
        {
          position: "absolute",
          top: 408,
          left: 20,
          width: "91%",
          height: "14%",
          backgroundColor: "#FBF8EF",
          borderWidth: 2,
          borderColor: "#000",
          borderStyle: "solid",
        },
      ],
    },
  },

  {
    templateDisplayName: "Template 14",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#B3C1C1",
      },
      beforeImage: {
        position: { x: 36, y: 120 },
        size: { width: "40%", height: "56%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#608686",
          borderRadius: 10,
          paddingTop: 40,
          borderWidth: 2,
          borderColor: "#fff",
          borderStyle: "solid",
          boxSizing: "border-box",
        },
      },
      afterImage: {
        position: { x: 270, y: 120 },
        size: { width: "40%", height: "56%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#608686",
          borderRadius: 10,
          paddingTop: 40,
          borderWidth: 2,
          borderColor: "#fff",
          borderStyle: "solid",
          boxSizing: "border-box",
        },
      },
      images: [
        {
          src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ1IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMTQ1IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0xNDQuMDYxIDEzLjA2MDdDMTQ0LjY0NiAxMi40NzQ5IDE0NC42NDYgMTEuNTI1MSAxNDQuMDYxIDEwLjkzOTNMMTM0LjUxNSAxLjM5MzRDMTMzLjkyOSAwLjgwNzYxIDEzMi45NzkgMC44MDc2MSAxMzIuMzkzIDEuMzkzNEMxMzEuODA4IDEuOTc5MTkgMTMxLjgwOCAyLjkyODkzIDEzMi4zOTMgMy41MTQ3MkwxNDAuODc5IDEyTDEzMi4zOTMgMjAuNDg1M0MxMzEuODA4IDIxLjA3MTEgMTMxLjgwOCAyMi4wMjA4IDEzMi4zOTMgMjIuNjA2NkMxMzIuOTc5IDIzLjE5MjQgMTMzLjkyOSAyMy4xOTI0IDEzNC41MTUgMjIuNjA2NkwxNDQuMDYxIDEzLjA2MDdaTTAgMTMuNUgxNDNWMTAuNUgwVjEzLjVaIiBmaWxsPSIjNjA4Njg2Ii8+Cjwvc3ZnPgo=",
          position: { x: 205, y: 260 },
          size: { width: "14%", height: "7.5%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "fill",
            backgroundColor: "#fff",
            borderRadius: 12,
            paddingRight: 10,
            paddingLeft: 10,
          },
        },
      ],
      texts: [
        {
          content: "before",
          position: { x: 140, y: 130 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 20,
            fontFamily: "Times New Roman",
            color: "#fff",
          },
        },
        {
          content: "after",
          position: { x: 370, y: 130 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 20,
            fontFamily: "Times New Roman",
            color: "#fff",
          },
        },
        {
          content: "Procedure Title",
          position: { x: 250, y: 40 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 45,
            color: "#fff",
            fontFamily: "Times New Roman",
          },
        },
        {
          content:
            "Short procedure description or necessary information. Keep info to two lines maximum.",
          position: { x: 250, y: 430 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            width: 250,
            fontSize: 11,
            color: "#fff",
            fontFamily: "Times New Roman",
            textAlign: "center",
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 15",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#E2CCCE",
      },
      beforeImage: {
        position: { x: 0, y: 0 },
        size: { width: "50%", height: "71%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          boxSizing: "border-box",
          borderStyle: "solid",
          borderColor: "#fff",
          borderWidth: 1,
          borderBottomWidth: 2,
        },
      },
      afterImage: {
        position: { x: 250, y: 0 },
        size: { width: "50%", height: "71%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          boxSizing: "border-box",
          borderStyle: "solid",
          borderColor: "#fff",
          borderWidth: 1,
          borderBottomWidth: 2,
        },
      },
      images: [],
      texts: [
        {
          content: "before",
          position: { x: 125, y: 334 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 18,
            fontFamily: "Arial",
            width: 135,
            borderRadius: 5,
            textAlign: "center",
            padding: 9,
            backgroundColor: "#DC9AA1",
            borderStyle: "solid",
            borderColor: "#fff",
            borderWidth: 2,
          },
        },
        {
          content: "after",
          position: { x: 375, y: 334 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 18,
            fontFamily: "Arial",
            width: 135,
            borderRadius: 5,
            textAlign: "center",
            padding: 9,
            backgroundColor: "#DC9AA1",
            borderStyle: "solid",
            borderColor: "#fff",
            borderWidth: 2,
          },
        },
        {
          content: "Procedure Title",
          position: { x: 250, y: 396 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 40,
            fontFamily: "Arial",
            fontWeight: "lighter",
            color: "#fff",
          },
        },
        {
          content:
            "Short procedure description ornecessary information. Keep info to two lines.",
          position: { x: 250, y: 445 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            width: 250,
            fontSize: 10,
            fontFamily: "Arial",
            textAlign: "center",
            color: "#fff",
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 16",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#658588",
      },
      beforeImage: {
        position: { x: 0, y: 0 },
        size: { width: "50%", height: "71%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          boxSizing: "border-box",
          borderStyle: "solid",
          borderColor: "#fff",
          borderWidth: 1,
          borderBottomWidth: 2,
        },
      },
      afterImage: {
        position: { x: 250, y: 0 },
        size: { width: "50%", height: "71%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          boxSizing: "border-box",
          borderStyle: "solid",
          borderColor: "#fff",
          borderWidth: 1,
          borderBottomWidth: 2,
        },
      },
      images: [],
      texts: [
        {
          content: "before",
          position: { x: 125, y: 334 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 18,
            fontFamily: "Arial",
            width: 135,
            borderRadius: 5,
            textAlign: "center",
            padding: 9,
            backgroundColor: "#9AAAAA",
            borderStyle: "solid",
            borderColor: "#fff",
            borderWidth: 2,
          },
        },
        {
          content: "after",
          position: { x: 375, y: 334 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 18,
            fontFamily: "Arial",
            width: 135,
            borderRadius: 5,
            textAlign: "center",
            padding: 9,
            backgroundColor: "#9AAAAA",
            borderStyle: "solid",
            borderColor: "#fff",
            borderWidth: 2,
          },
        },
        {
          content: "Procedure Title",
          position: { x: 250, y: 396 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 40,
            fontFamily: "Arial",
            fontWeight: "lighter",
            color: "#fff",
          },
        },
        {
          content:
            "Short procedure description ornecessary information. Keep info to two lines.",
          position: { x: 250, y: 445 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            width: 250,
            fontSize: 10,
            fontFamily: "Arial",
            textAlign: "center",
            color: "#fff",
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 17",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#F1E8DD",
      },
      beforeImage: {
        position: { x: 0, y: 0 },
        size: { width: "50%", height: "71%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          boxSizing: "border-box",
          borderStyle: "solid",
          borderColor: "#000",
          borderWidth: 1,
          borderBottomWidth: 2,
        },
      },
      afterImage: {
        position: { x: 250, y: 0 },
        size: { width: "50%", height: "71%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          boxSizing: "border-box",
          borderStyle: "solid",
          borderColor: "#000",
          borderWidth: 1,
          borderBottomWidth: 2,
        },
      },
      images: [],
      texts: [
        {
          content: "before",
          position: { x: 126, y: 30 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 16,
            fontFamily: "Arial",
            width: 105,
            borderStyle: "solid",
            borderColor: "#000",
            borderWidth: 1.5,
            borderRadius: 20,
            textAlign: "center",
            padding: 5,
            backgroundColor: "#F1E8DD",
          },
        },
        {
          content: "after",
          position: { x: 374, y: 30 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 16,
            fontFamily: "Arial",
            width: 105,
            borderStyle: "solid",
            borderColor: "#000",
            borderWidth: 1.5,
            borderRadius: 20,
            textAlign: "center",
            padding: 5,
            backgroundColor: "#F1E8DD",
          },
        },
        {
          content: "Procedure Title",
          position: { x: 472, y: 384 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-100%)",
            textWrap: "nowrap",
            fontSize: 40,
            fontFamily: "Arial",
            fontWeight: "lighter",
          },
        },
        {
          content:
            "Short procedure description ornecessary information. Keep info to two lines.",
          position: { x: 472, y: 443 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-100%)",
            width: 250,
            fontSize: 11,
            color: "#000",
            fontFamily: "Arial",
            textAlign: "right",
          },
        },
      ],
      divs: [
        {
          position: "absolute",
          top: 44,
          left: 0,
          width: 4,
          height: 4,
          borderRadius: 100,
          backgroundColor: "#000",
          zIndex: 1,
        },
        {
          position: "absolute",
          top: 44,
          right: 0,
          width: 4,
          height: 4,
          borderRadius: 100,
          backgroundColor: "#000",
          zIndex: 1,
        },
        {
          position: "absolute",
          top: 44,
          left: 430,
          width: 4,
          height: 4,
          borderRadius: 100,
          backgroundColor: "#000",
          zIndex: 1,
        },
        {
          position: "absolute",
          top: 44,
          left: 314,
          width: 4,
          height: 4,
          borderRadius: 100,
          backgroundColor: "#000",
          zIndex: 1,
        },
        {
          position: "absolute",
          top: 44,
          left: 182,
          width: 4,
          height: 4,
          borderRadius: 100,
          backgroundColor: "#000",
          zIndex: 1,
        },
        {
          position: "absolute",
          top: 44,
          left: 66,
          width: 4,
          height: 4,
          borderRadius: 100,
          backgroundColor: "#000",
          zIndex: 1,
        },
        {
          position: "absolute",
          top: 45,
          width: "100%",
          height: 1.5,
          backgroundColor: "#000",
        },
      ],
    },
  },

  {
    templateDisplayName: "Template 18",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#F7F5F0",
      },
      beforeImage: {
        position: { x: 32, y: 37 },
        size: { width: "43.5%", height: "62%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          borderRadius: 20,
          borderWidth: 2,
          borderColor: "#000",
          borderStyle: "solid",
          boxSizing: "border-box",
        },
      },
      afterImage: {
        position: { x: 248, y: 95 },
        size: { width: "43.5%", height: "62%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          borderRadius: 20,
          borderWidth: 2,
          borderColor: "#000",
          borderStyle: "solid",
          boxSizing: "border-box",
        },
      },
      images: [
        {
          src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCA0NiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMiAxMC41QzEuMTcxNTcgMTAuNSAwLjUgMTEuMTcxNiAwLjUgMTJDMC41IDEyLjgyODQgMS4xNzE1NyAxMy41IDIgMTMuNVYxMC41Wk00NS4wNjA3IDEzLjA2MDdDNDUuNjQ2NCAxMi40NzQ5IDQ1LjY0NjQgMTEuNTI1MSA0NS4wNjA3IDEwLjkzOTNMMzUuNTE0NyAxLjM5MzRDMzQuOTI4OSAwLjgwNzYxNCAzMy45NzkyIDAuODA3NjE0IDMzLjM5MzQgMS4zOTM0QzMyLjgwNzYgMS45NzkxOSAzMi44MDc2IDIuOTI4OTcgMzMuMzkzNCAzLjUxNDc1TDQxLjg3ODcgMTJMMzMuMzkzNCAyMC40ODUzQzMyLjgwNzYgMjEuMDcxIDMyLjgwNzYgMjIuMDIwOCAzMy4zOTM0IDIyLjYwNjZDMzMuOTc5MiAyMy4xOTI0IDM0LjkyODkgMjMuMTkyNCAzNS41MTQ3IDIyLjYwNjZMNDUuMDYwNyAxMy4wNjA3Wk0yIDEzLjVINDRWMTAuNUgyVjEzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K",
          position: { x: 225, y: 200 },
          size: { width: "10%", height: "10%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "fill",
            backgroundColor: "#F3E2BE",
            padding: 10,
            borderRadius: 100,
            borderStyle: "solid",
            borderColor: "#000",
            borderWidth: 2,
            boxSizing: "border-box",
          },
        },
      ],
      texts: [
        {
          content: "before",
          position: { x: 78, y: 62 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 16,
            fontFamily: "Arial",
            padding: 4,
            borderWidth: 2,
            borderColor: "#000",
            borderStyle: "solid",
            borderRadius: 20,
            backgroundColor: "#F3E2BE",
            width: 110,
            textAlign: "center",
            color: "#000",
          },
        },
        {
          content: "after",
          position: { x: 433, y: 357 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontSize: 16,
            fontFamily: "Arial",
            padding: 4,
            borderWidth: 2,
            borderColor: "#000",
            borderStyle: "solid",
            borderRadius: 20,
            backgroundColor: "#F3E2BE",
            width: 110,
            textAlign: "center",
            color: "#000",
          },
        },
        {
          content: "Procedure Title",
          position: { x: 32, y: 385 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            fontSize: 41,
            color: "#000",
            fontFamily: "Arial",
          },
        },
        {
          content:
            "Short procedure description or necessary information. Keep info to two lines maximum.",
          position: { x: 460, y: 450 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-100%)",
            width: 250,
            fontSize: 11,
            color: "#000",
            fontFamily: "Arial",
            textAlign: "right",
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 23",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#fff",
      },
      beforeImage: {
        position: { x: 0, y: 0 },
        size: { width: "50%", height: "100%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      },
      afterImage: {
        position: { x: 250, y: 0 },
        size: { width: "50%", height: "100%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      },
      images: [],
      texts: [
        {
          content: "Before",
          position: { x: 125, y: 30 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Arial",
            fontSize: 20,
            paddingLeft: 10,
            paddingRight: 10,
            backgroundColor: "#F1E8DD",
            borderRadius: 20,
          },
        },
        {
          content: "After",
          position: { x: 375, y: 440 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Arial",
            fontSize: 20,
            paddingLeft: 10,
            paddingRight: 10,
            backgroundColor: "#F1E8DD",
            borderRadius: 20,
          },
        },
      ],
      divs: [
        {
          position: "absolute",
          top: 0,
          left: 250,
          width: 5,
          transform: "translateX(-50%)",
          height: "100%",
          background: "#fff",
        },
      ],
    },
  },

  {
    templateDisplayName: "Template 23",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#fff",
      },
      beforeImage: {
        position: { x: 0, y: 0 },
        size: { width: "50%", height: "100%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      },
      afterImage: {
        position: { x: 250, y: 0 },
        size: { width: "50%", height: "100%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      },
      images: [
        {
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_SQUARE_0001.png",
          position: { x: 225, y: 225 },
          size: { width: "9.5%", height: "9.5%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
      ],
      texts: [
        {
          content: "Before",
          position: { x: 125, y: 30 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Arial",
            fontSize: 20,
            paddingLeft: 10,
            paddingRight: 10,
            backgroundColor: "#F1E8DD",
            borderRadius: 20,
          },
        },
        {
          content: "After",
          position: { x: 375, y: 440 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Arial",
            fontSize: 20,
            paddingLeft: 10,
            paddingRight: 10,
            backgroundColor: "#F1E8DD",
            borderRadius: 20,
          },
        },
      ],
      divs: [
        {
          position: "absolute",
          top: 0,
          left: 250,
          width: 5,
          transform: "translateX(-50%)",
          height: "100%",
          background: "#fff",
        },
      ],
    },
  },

  {
    templateDisplayName: "Template 26",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#fff",
      },
      beforeImage: {
        position: { x: 125, y: 0 },
        size: { width: "50%", height: "50%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      },
      afterImage: {
        position: { x: 125, y: 250 },
        size: { width: "50%", height: "50%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      },
      images: [
        {
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_RECTANGLE_0001.png",
          position: { x: 210, y: 225 },
          size: { width: `${320 / 18}%`, height: `${180 / 18}%` },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
      ],
      texts: [
        {
          content: "Before",
          position: { x: 250, y: 20 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Arial",
            fontSize: 15,
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 3,
            paddingBottom: 3,
            backgroundColor: "#F1E8DD",
            borderRadius: 20,
          },
        },
        {
          content: "After",
          position: { x: 250, y: 455 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Arial",
            fontSize: 15,
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 3,
            paddingBottom: 3,
            backgroundColor: "#F1E8DD",
            borderRadius: 20,
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 26",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#D9929A",
      },
      beforeImage: {
        position: { x: 0, y: 0 },
        size: { width: "50%", height: "73%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      },
      afterImage: {
        position: { x: 250, y: 0 },
        size: { width: "50%", height: "73%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      },
      images: [
        {
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_RECTANGLE_0001.png",
          position: { x: 330, y: 405 },
          size: { width: `${320 / 18}%`, height: `${180 / 18}%` },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
      ],
      texts: [
        {
          content: "Procedure Title",
          position: { x: 30, y: 390 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            textWrap: "nowrap",
            fontFamily: "Times New Roman",
            fontSize: 30,
          },
        },
        {
          content: "145 lbs",
          position: { x: 30, y: 430 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            textWrap: "nowrap",
            fontFamily: "Arial",
            fontSize: 10,
          },
        },
        {
          content: "39 years old",
          position: { x: 30, y: 445 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            textWrap: "nowrap",
            fontFamily: "Arial",
            fontSize: 10,
          },
        },
        {
          content: "BMI 36",
          position: { x: 30, y: 460 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            textWrap: "nowrap",
            fontFamily: "Arial",
            fontSize: 10,
          },
        },
      ],
      divs: [
        {
          position: "absolute",
          top: 0,
          left: 250,
          width: "0.5%",
          height: "100%",
          backgroundColor: "#E9C1C1",
        },
      ],
    },
  },

  {
    templateDisplayName: "Template 27",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#F1E8DD",
      },
      beforeImage: {
        position: { x: 140, y: 62 },
        size: { width: "44%", height: "31%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 20,
          borderWidth: 1,
          borderColor: "#000",
          borderStyle: "solid",
        },
      },
      afterImage: {
        position: { x: 140, y: 250 },
        size: { width: "44%", height: "31%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 20,
          borderWidth: 1,
          borderColor: "#000",
          borderStyle: "solid",
        },
      },
      images: [
        {
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_RECTANGLE_0001.png",
          position: { x: 215, y: 455 },
          size: { width: `${320 / 23}%`, height: `${180 / 23}%` },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
      ],
      texts: [
        {
          content: "Procedure Title",
          position: { x: 250, y: 25 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Times New Roman",
            fontSize: 19,
          },
        },
        {
          content: "Before",
          position: { x: 250, y: 220 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Times New Roman",
            fontSize: 14,
          },
        },
        {
          content: "After",
          position: { x: 250, y: 410 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Times New Roman",
            fontSize: 14,
          },
        },
        {
          content:
            "Short procedure description or necessary information. Keep info to two lines maximum.",
          position: { x: 250, y: 430 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            fontFamily: "Times New Roman",
            textAlign: "center",
            fontSize: 9,
            width: 200,
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 28",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#F1E8DD",
      },
      beforeImage: {
        position: { x: 21, y: 111 },
        size: { width: "43%", height: "54%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "100%",
          borderWidth: 2,
          borderColor: "#000",
          borderStyle: "solid",
        },
      },
      afterImage: {
        position: { x: 261, y: 111 },
        size: { width: "43%", height: "54%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "100%",
          borderWidth: 2,
          borderColor: "#000",
          borderStyle: "solid",
        },
      },
      images: [
        {
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_RECTANGLE_0001.png",
          position: { x: 195, y: 430 },
          size: { width: `${320 / 15}%`, height: `${180 / 15}%` },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
      ],
      texts: [
        {
          content: "Procedure Title",
          position: { x: 250, y: 20 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Times New Roman",
            fontSize: 36,
          },
        },
        {
          content:
            "Short procedure description or necessary information. Keep info to two lines maximum.",
          position: { x: 250, y: 67 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            fontFamily: "Times New Roman",
            textAlign: "center",
            fontSize: 9,
            width: 200,
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 29",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500,
        backgroundColor: "#EAE7E3",
      },
      beforeImage: {
        position: { x: 39, y: 113 },
        size: { width: "38%", height: "60%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 30,
        },
      },
      afterImage: {
        position: { x: 275, y: 113 },
        size: { width: "38%", height: "60%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 30,
        },
      },
      images: [
        {
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_RECTANGLE_0001.png",
          position: { x: 200, y: 435 },
          size: { width: `${320 / 16}%`, height: `${180 / 16}%` },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
        {
          src: "https://clinic-os.com/user-app-assets/template-other-images/before-after-frame-0001.png",
          position: { x: 20, y: 94 },
          size: { width: "45%", height: "67%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "fill",
          },
        },
        {
          src: "https://clinic-os.com/user-app-assets/template-other-images/before-after-frame-0001.png",
          position: { x: 255, y: 94 },
          size: { width: "45%", height: "67%" },
          containerStyle: {},
          imageStyle: {
            width: "100%",
            height: "100%",
            objectFit: "fill",
          },
        },
      ],
      texts: [
        {
          content: "Procedure Title",
          position: { x: 250, y: 20 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textWrap: "nowrap",
            fontFamily: "Times New Roman",
            fontSize: 36,
          },
        },
        {
          content: "Deep plane face lift",
          position: { x: 250, y: 67 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            fontFamily: "Times New Roman",
            textAlign: "center",
            fontSize: 9,
            width: 200,
          },
        },
      ],
      divs: [],
    },
  },

  {
    templateDisplayName: "Template 30",
    template: {
      outerContainer: {
        position: "relative",
        width: 1000,
        height: 500 * 2,
        backgroundColor: "#000",
      },

      // Side-by-side images with rounded corners
      beforeImage: {
        position: { x: 40, y: 260 },
        size: { width: "44%", height: "58%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          borderRadius: 16,
        },
      },
      afterImage: {
        position: { x: 260 * 2, y: 260 },
        size: { width: "44%", height: "58%" },
        containerStyle: {},
        imageStyle: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          backgroundColor: "#000",
          borderRadius: 16,
        },
      },

      // Top logo (swap src as needed)
      images: [
        {
          // Put the image in a container and center it. otherwise it wont work
          src: "https://clinic-os.com/user-app-assets/template-logo-placeholder/TEMPLATE_LOGO_RECTANGLE_0001.png",
          position: { x: 0, y: 20 }, // anchor at the left edge
          size: { width: "100%", height: 175 }, // container spans the canvas width
          containerStyle: {
            position: "absolute",
            left: 0,
            transform: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2,
          },
          imageStyle: {
            width: 275,
            height: "100%",
            objectFit: "contain",
            backgroundColor: "transparent",
            display: "block",
          },
        },
      ],

      texts: [
        // Before / After labels (bottom-left inside each image)
        {
          content: "Before",
          position: { x: 80, y: 800 },
          containerStyle: { position: "absolute", zIndex: 3 },
          textStyle: {
            fontFamily: "Arial",
            fontSize: 24,
            color: "#fff",
            opacity: 1,
          },
        },
        {
          content: "After",
          position: { x: 560, y: 800 },
          containerStyle: { position: "absolute", zIndex: 3 },
          textStyle: {
            fontFamily: "Arial",
            fontSize: 24,
            color: "#fff",
            opacity: 1,
          },
        },

        {
          content: "SURGEON NAME",
          position: { x: 500, y: 190 },
          containerStyle: { zIndex: 2 },
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            fontFamily: "Arial",
            fontWeight: 500,
            textAlign: "center",
            width: 500,
            textWrap: "nowrap",
            fontSize: 24,
            color: "#fff",
          },
        },

        // Small caption
        {
          content: "3 months post op",
          position: { x: 500, y: 875 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textAlign: "center",
            width: 500,
            fontFamily: "Arial",
            fontSize: 24,
            color: "#bfbfbf",
            // letterSpacing: 0.2,
          },
        },

        // Big two-line title
        {
          content: "Procedure Name",
          position: { x: 500, y: 920 },
          containerStyle: {},
          textStyle: {
            position: "absolute",
            transform: "translateX(-50%)",
            textAlign: "center",
            width: 700,
            fontFamily: "Arial",
            fontWeight: 700,
            fontSize: 44,
            color: "#fff",
          },
        },
      ],

      divs: [],
    },
  },

  //
];
